import React, { useState } from "react";
import { Link } from "react-router-dom";
import DetectedContacts from "./DetectedContacts";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import BulkIcon from "../../assets/icons/Icon_Library/application icons/general/bulk_manage.svg2";
import ManageIcon from "../../assets/icons/Icon_Library/application icons/general/manage_fields.svg2";

import PageHeader from "../Common/PageHeader";
import WhiteButton from "../Common/WhiteButton";
import HelpButton from "../HelpContent/HelpButton";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

const emptyFilters2 = [
  {
    values: [],
    is_or: true,
    fields: [],
    formats: ["primary"],
    order: 0,
    operator: "is",
  },
];

export default function AddBulk() {
  const [filters2, setFilters2] = useState(emptyFilters2);

  return (
    <>
      <div className="">
        <PageHeader
          Icon={BulkIcon}
          heading="Add contacts in bulk"
          subheading="Copy and paste contacts."
        >
          <div className="">
            <WhiteButtonDropdown
              toggleHeading={"Actions"}
              toggleSubheading={"Add contacts in bulk"}
            >
              <WhiteButton
                as="RRLink"
                to="/assets/contacts/add"
                icon={ContactsIcon}
                heading="Add"
                subheading="Contact"
              />
              <WhiteButton
                as="RRLink"
                to="/assets/contacts/fields"
                icon={ManageIcon}
                heading="Manage"
                subheading="Fields"
              />
            </WhiteButtonDropdown>
          </div>
        </PageHeader>

        <textarea
          placeholder="Enter phone number or email to start adding new contacts. Separate multiple items by commas."
          className="form-control"
          style={{ minHeight: 300 }}
          type="text"
          value={filters2?.[0]?.values?.join(",") || ""}
          onChange={(e) =>
            setFilters2((prev) => [
              {
                ...prev[0],
                values: [
                  ...new Set(
                    e.target.value.split(/[\n,]+/).map((v) => v.trim())
                  ),
                ],
              },
            ])
          }
        />
      </div>
      <DetectedContacts filters={filters2} />
    </>
  );
}
